import React, { useState } from "react";
import { Box, Typography, Select, MenuItem, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { get_auth_process_states, get_auth_user_data, get_current_role, get_enabled_client_list, get_roles_list } from "../../redux/auth/auth.selectors";
import { useDispatch } from "react-redux";
import { logout_dispatch, select_plant_dispatch } from "../../redux/auth/auth.actions";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { LogoutOutlined } from "@mui/icons-material";
import { mixpanelLoginFunction } from "../../mixPanelFunctions/mixPanelFunctions";

const PlantSelectionPage = () => {
  const navigate = useNavigate();
  const [loading, set_loading] = useState(false);
  const clientList = useSelector(get_enabled_client_list);
  const [selected_client, set_selected_client] = useState(clientList && clientList?.length === 1 ? clientList[0] : "none");
  const user_data = useSelector(get_auth_user_data);
  const handleClientChange = (event) => {
    const selectedClientId = event.target.value;
    set_selected_client(selectedClientId);
    // Perform any necessary actions with the selected client ID
  };

  const roles_list = useSelector(get_roles_list);
  const default_role = useSelector(get_current_role);
  console.log({ roles_list });
  const [selected_role, set_selected_role] = useState(default_role);

  const handleRoleChange = (event) => {
    const selectedRole = event.target.value;
    set_selected_role(selectedRole);
    // Perform any necessary actions with the selected client ID
  };

  const dispatch = useDispatch();

  const confirm_plant = () => {
    set_loading(true);
    mixpanelLoginFunction(user_data?.email,user_data?.name,selected_role,selected_client) // mixpanel login function
    dispatch(select_plant_dispatch(selected_client, selected_role));
    setTimeout(() => {
      set_loading(false);
      navigate("/");
    }, 1500);
  };

  const { auth_process_loading } = useSelector(get_auth_process_states);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" gap="30px">
      <img alt="Optimus" src={"./optimus.png"} />
      {clientList.length === 0 ? (
        <Typography variant="body1" style={{ marginBottom: 8, color: "#000" }}>
          Waiting for admin to give you access to a plant
        </Typography>
      ) : (
        <>
          <div>
            <Box className="my-2" minWidth={230}>
              <p className="text-xs">Select your plant</p>
              <Select
                value={selected_client}
                onChange={(event) => {
                  handleClientChange(event);
                }}
                style={{ minWidth: "100%" }}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                <MenuItem disabled value="none">
                  Choose your plant
                </MenuItem>
                {clientList.map((clientId) => (
                  <MenuItem key={clientId} value={clientId} sx={{ textTransform: "capitalize" }}>
                    {clientId?.split("_").join(" ")}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <div className="my-2">
              <p className="text-xs">Select your role</p>
              <Select
                value={selected_role}
                onChange={(event) => {
                  handleRoleChange(event);
                }}
                style={{ minWidth: "100%" }}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                <MenuItem disabled value="none">
                  Choose your role
                </MenuItem>
                {
                  roles_list?.map((role) => (
                    <MenuItem key={role} value={role} sx={{ textTransform: "capitalize" }}>
                      {role?.split("_").join(" ")}
                    </MenuItem>
                  ))
                }
              </Select>
            </div>
          </div>
          <LoadingButton
            disabled={selected_client === "none"}
            loading={loading}
            variant="contained"
            color="primary"
            sx={{ color: "white" }}
            onClick={confirm_plant}
          >
            Choose Plant
          </LoadingButton>
        </>
      )}
      <Box className={`justify-start my-2 flex items-center gap-3 border border-red-500 rounded p-3 ${auth_process_loading ? "text-gray-500 border-gray-400" : "hover:text-red-500 hover:cursor-pointer"}`}
        onClick={() => {
          if (!auth_process_loading) {
            dispatch(logout_dispatch());
          }
        }}
      >
        {
          auth_process_loading && <CircularProgress size={20} color="inherit" />
        }
        <LogoutOutlined />
        {
          <Typography>Logout</Typography>
        }
      </Box>
    </Box>
  );
};

export default PlantSelectionPage;
